import * as React from "react";
import {Outlet} from "react-router";
import {useIntl} from "react-intl";
import {loadQuery} from "react-relay/hooks";
import BreadcrumbNavigation from "./navigation/BreadcrumbNavigation";
import SecondaryNavigation from "./navigation/SecondaryNavigation";
import OutgoingInvoicesViewInvoicesQuery from "./__generated__/OutgoingInvoicesViewInvoicesQuery.graphql";
import SuppliersViewQuery from "./__generated__/SuppliersViewQuery.graphql";

type InvoicesViewProps = {
    prepared: any
};

/**
 * The invoices area with its outgoing invoices, incoming invoices and suppliers. It passes the
 * preloaded queries on to the view shown.
 */
const InvoicesView: React.FC<InvoicesViewProps> = (props) => {
    const intl = useIntl();

    const breadcrumbNavigationItems = [
        {label: intl.formatMessage({id: 'navigation.invoices'}), to: '/invoices'},
    ];

    const secondaryNavigationItems = [
        {
            label: intl.formatMessage({id: 'tab.invoices.outgoing'}),
            to: '/invoices/outgoing',
        },
        {
            label: intl.formatMessage({id: 'tab.invoices.incoming'}),
            to: '/invoices/incoming',
        },
        {
            label: intl.formatMessage({id: 'tab.invoices.suppliers'}),
            to: '/invoices/suppliers',
        },
    ];

    return (
        <>
            <BreadcrumbNavigation items={breadcrumbNavigationItems}/>
            <div className="py-4 md:flex md:items-center md:justify-between">
                <div className="flex-1 min-w-0">
                    <div className="mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 gap-x-4 gap-y-8">
                        <div className="flex items-center space-x-5">
                            <h1 className="text-xl sm:text-2xl font-bold text-gray-900">{intl.formatMessage({id: 'navigation.invoices'})}</h1>
                        </div>
                    </div>
                </div>
            </div>
            <SecondaryNavigation items={secondaryNavigationItems}/>
            <div className="lg:mt-6 mx-auto lg:px-8 grid grid-cols-1 gap-x-4 gap-y-8">
                <Outlet context={props.prepared}/>
            </div>
        </>
    );
};

export default InvoicesView;

function prepare_InvoicesView(_params: any, relayEnvironment: any) {
    return {
        invoicesQuery: loadQuery(
            relayEnvironment,
            OutgoingInvoicesViewInvoicesQuery,
            {},
            {fetchPolicy: 'store-and-network'},
        ),
        expenseSuppliersQuery: loadQuery(
            relayEnvironment,
            SuppliersViewQuery,
            {},
            {fetchPolicy: 'store-and-network'},
        ),
    };
}

export {prepare_InvoicesView};
